export function BellIcon() {
    return (
        <svg
            width={24}
            height={24}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4 17l-.67-.335A.75.75 0 004 17.75V17zm16 0v.75a.75.75 0 00.67-1.085L20 17zM6.75 9c0-2.9 2.35-5.25 5.25-5.25v-1.5A6.75 6.75 0 005.25 9h1.5zM12 3.75c2.9 0 5.25 2.35 5.25 5.25h1.5A6.75 6.75 0 0012 2.25v1.5zM5.25 9c0 1.887-.474 3.8-.962 5.263a22.82 22.82 0 01-.882 2.24 9.573 9.573 0 01-.059.124l-.014.03-.003.007h-.001c0 .001 0 .001 0 0a241.364 241.364 0 011.342.671v-.001l.002-.004.006-.01a6.554 6.554 0 00.087-.183 24.31 24.31 0 00.946-2.4C6.224 13.2 6.75 11.113 6.75 9h-1.5zM4 17.75h16v-1.5H4v1.5zM20 17l.67-.335h.001v-.001a.525.525 0 01-.004-.007l-.014-.03a16.84 16.84 0 01-.276-.61 22.829 22.829 0 01-.665-1.754C19.224 12.8 18.75 10.887 18.75 9h-1.5c0 2.113.526 4.2 1.038 5.737a24.3 24.3 0 00.946 2.4l.068.144.02.039.005.01.001.004.001.001L20 17zm-5.75 1A2.25 2.25 0 0112 20.25v1.5A3.75 3.75 0 0015.75 18h-1.5zM12 20.25A2.25 2.25 0 019.75 18h-1.5A3.75 3.75 0 0012 21.75v-1.5zM9.75 18v-1h-1.5v1h1.5zm6 0v-1h-1.5v1h1.5z'
                fill='#8692A6'
            />
        </svg>
    )
}

export function KeyIcon() {
    return (
        <svg
            width={24}
            height={24}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M11.691 12.309L21.002 3M18 6l2 2-3 3-2-2m-2 6.5A4.501 4.501 0 118.499 11 4.502 4.502 0 0113 15.5z'
                stroke='#8692A6'
                strokeWidth={1.5}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function ToggleIcon() {
    return (
        <svg
            width={12}
            height={12}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <circle cx={6} cy={6} r={5} stroke='#F5F7F9' strokeWidth={2} />
        </svg>
    )
}
